var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DgConnector = /** @class */ (function () {
    function DgConnector(dgEndpoint) {
        this.endpoint = dgEndpoint;
    }
    DgConnector.prototype.getMessages = function (packageName, opts) {
        return __awaiter(this, void 0, Promise, function () {
            var queryURL, request, response, messages, _i, _a, msg, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryURL = new URL(this.endpoint);
                        queryURL.pathname += "/raw";
                        queryURL.searchParams.append("package", packageName);
                        queryURL.searchParams.append("meta", "subtitle");
                        queryURL.searchParams.append("meta", "link");
                        queryURL.searchParams.append("meta", "icon");
                        queryURL.searchParams.append("meta", "date");
                        queryURL.searchParams.append("not_topic", "org.fedoraproject.prod.mdapi.repo.update");
                        queryURL.searchParams.append("not_topic", "org.fedoraproject.prod.buildsys.rpm.sign");
                        queryURL.searchParams.append("not_topic", "org.fedoraproject.prod.buildsys.tag");
                        queryURL.searchParams.append("not_topic", "org.fedoraproject.prod.buildsys.untag");
                        queryURL.searchParams.append("not_topic", "org.fedoraproject.prod.buildsys.package.list.change");
                        queryURL.searchParams.append("not_topic", "org.release-monitoring.prod.anitya.project.version.update.v2");
                        if (opts === null || opts === void 0 ? void 0 : opts.page) {
                            queryURL.searchParams.append("page", String(opts.page));
                        }
                        if (opts === null || opts === void 0 ? void 0 : opts.delta) {
                            queryURL.searchParams.append("delta", String(opts.delta));
                        }
                        if (opts === null || opts === void 0 ? void 0 : opts.end) {
                            queryURL.searchParams.append("end", String(opts.end));
                        }
                        if (opts === null || opts === void 0 ? void 0 : opts.start) {
                            queryURL.searchParams.append("start", String(opts.start));
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(queryURL.href)];
                    case 2:
                        request = _b.sent();
                        if (!request.ok) {
                            console.error("Request error:", request);
                            return [2 /*return*/, "Error: Could not connect to Datagrepper"];
                        }
                        return [4 /*yield*/, request.json()];
                    case 3:
                        response = _b.sent();
                        messages = [];
                        for (_i = 0, _a = response.raw_messages; _i < _a.length; _i++) {
                            msg = _a[_i];
                            messages.push(__assign(__assign({}, msg.meta), { id: msg.msg_id }));
                        }
                        return [2 /*return*/, {
                                messages: messages,
                                pages: response.pages,
                                page: response.arguments.page,
                                count: response.count
                            }];
                    case 4:
                        e_1 = _b.sent();
                        return [2 /*return*/, String(e_1)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DgConnector;
}());
export { DgConnector };
